import { render, staticRenderFns } from "./InputLanguageSuggest.vue?vue&type=template&id=da4e7760&scoped=true&"
import script from "./InputLanguageSuggest.vue?vue&type=script&lang=js&"
export * from "./InputLanguageSuggest.vue?vue&type=script&lang=js&"
import style0 from "./InputLanguageSuggest.vue?vue&type=style&index=0&id=da4e7760&prod&scoped=true&lang=css&"
import style1 from "./InputLanguageSuggest.vue?vue&type=style&index=1&id=da4e7760&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da4e7760",
  null
  
)

export default component.exports